import { trimSlashes } from './trim-slashes';

export const removeVersionFromPath = (path: string): string => trimSlashes(path).replace(/\/[^/]+$/, '');
